import translations from '../i18n/translations';

// Passenger UI is Arabic-only
export const useLanguage = () => ({
  lang: 'ar',
  setLang: () => {},
  toggleLang: () => {},
  t: translations.ar,
  isRTL: true,
});
